import React, { useState, useEffect } from "react";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import "../Projects/project.css";
import { handleFreeTrials, handleProjectlist } from '../Utils/utils';
import ReactPaginate from 'react-paginate';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import moment from 'moment';
import Loaderspinner from "../../components/Loader";
import { handleExportProjectlist, showToast } from "../Utils/utils";
import { Tooltip } from 'react-tooltip'
import axios from "axios";
import { adminServiceUrl } from "../Config/config";

const FreeTrialsList = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [typeStatus, setTypeStatus] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false);
  const [trialInput, setTrialInput] = useState('');
  const [search, setSearch] = useState('');
  const [userId, setUserId] = useState('');

  const role = localStorage.getItem("role")

  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };
  const fetchRaisers = async () => {
    try {
      setLoading(true)
      const token = localStorage.getItem("token");
      const limit = 10;
      const offset = page * limit;

      const response = await handleFreeTrials({
        type: typeStatus,
        limit,
        offset,
        token,
        search
      });

      setProjectList(response?.data || []);

      if ((response?.data?.length || 0) < limit) {
        setTotalPages(page + 1);
      } else {
        setTotalPages(page + 2);
      }

    } catch (error) {
      console.error("Error fetching lenders:", error);
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    if (search.length == 0) {
      fetchRaisers();
    } else if (search.length >= 3) {
      fetchRaisers();
    }
  }, [typeStatus, page, search]);

  const onConfirm = async () => {

    try {
      const token = localStorage.getItem("token");
      const requestBody = {
        userid: userId,
        days: parseInt(trialInput)
      };
      const response = await axios.post(
        `${adminServiceUrl}/extend-user-trial-subscription`,
        requestBody,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      showToast(response.data.message, "success");
      fetchRaisers();
      setTrialInput('')
      setShowModal(false)
    } catch (error) {
      showToast(error);
      setShowModal(false)
    }
  }
  return (
    <>
      {loading && <Loaderspinner />}
      <div class="g-sidenav-show  bg-gray-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />

            <div className="header header-bg pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <nav
                        aria-label="breadcrumb"
                        className="d-none d-md-inline-block ml-md-4"
                      >
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                          <li className="breadcrumb-item">
                            <Link to="/dashboard">
                              <i className="fas fa-home" />
                            </Link>
                          </li>
                          <li className="breadcrumb-item mt-2">
                            <span className="" style={{ color: "#f6f9fc" }}>Free Trials</span>
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-header border-0">
                      <div className="d-flex justify-content-between">
                        <div className="row ">
                          <h5 className="mb-0 w-auto">Free Trials</h5>
                          <p
                            className="w-auto px-0"
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content="A complete list of all projects created by borrowers. Use this report to review project details, check status, and ensure projects comply with platform guidelines."
                            data-tooltip-place="right"
                          >
                            <i className="fas fa-info-circle" />

                          </p>

                          <Tooltip id="my-tooltip" style={{ width: '30%' }} />
                        </div>
                        <div class="row" style={{ justifyContent: 'space-between' }}>
                          <input
                            className="form-control"
                            style={{ width: '60%', borderRadius: '40px' }}
                            placeholder="Search"
                            onChange={(e) => {
                              setSearch(e.target.value)
                            }}
                            value={search}
                          />
                          <select
                            className="custom-select-dropdown font-bold"
                            value={typeStatus}
                            onChange={(e) => setTypeStatus(e.target.value)}
                          >
                            <option value="" className='option'>All</option>
                            <option value="active" className='option'>Active</option>
                            <option value="expired" className='option'>Expired</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            {role !== "virtual_assistant" &&
                              <th>Action</th>
                            }
                            <th>Name</th>
                            <th>Email</th>
                            <th>Usertype</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {projectList?.length > 0 ? (
                            projectList.map((project, index) => (
                              <tr key={index}>
                                {role !== "virtual_assistant" &&
                                  <td>
                                    <div style={{ width: "120px" }}>
                                      <button className="viewproject-btn pull-right mb-1" onClick={() => {
                                        setUserId(project?.userid)
                                        setShowModal(true)
                                      }}>
                                        <span className="text-white">Extend Trial</span>
                                      </button>
                                    </div>
                                  </td>
                                }
                                <td className="table-user">
                                  <div>
                                    <span style={{ textTransform: 'capitalize' }}>{project?.about?.name} {project?.about?.lastname}</span>
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div>
                                    <span >{project?.about?.email}</span>
                                  </div>
                                </td>

                                <td className="table-user">
                                  <div style={{ width: "120px", textTransform: 'capitalize' }}><span>{project?.about?.usertype} </span></div>
                                </td>
                                <td className="table-user">
                                  <div style={{ width: "120px" }}>
                                    {moment(project?.trial_valid_till).isBefore(moment(), 'day')
                                      ?
                                      <span style={{ color: 'red', fontWeight: 600 }}>Expired (Expired at {moment(project?.trial_valid_till).format("MM/DD/YYYY")})</span>
                                      :
                                      <span style={{ color: 'green', fontWeight: 600 }}>Active (Expires at {moment(project?.trial_valid_till).format("MM/DD/YYYY")})</span>

                                    }
                                  </div>
                                </td>

                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center"><b>No records found</b></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <Row>
                <Col xs={12}>
                  <div className='paginate-css'>
                    <ReactPaginate
                      previousLabel="<"
                      nextLabel=">"
                      breakLabel="..."
                      pageCount={totalPages}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={({ selected }) => setPage(selected)}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </main>
          <Modal show={showModal} onHide={() => setShowModal(false)} >
            <Modal.Header closeButton>
              <Modal.Title>{"Extend Trial"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                {"How many days to extend?"}
              </div>
              <input
                // type="password"
                type="number"
                className="form-control mt-3"
                style={{ width: '50%' }}
                placeholder="Enter number of days"
                onChange={(e) =>
                  setTrialInput(e.target.value)
                }
                value={trialInput}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)} style={{ backgroundColor: '#cccccc', color: '#333333', border: 'none' }}>
                Close
              </Button>
              <Button variant="primary" style={{ backgroundColor: '#87BFBB', color: '#000000', border: 'none' }} onClick={onConfirm}>
                Save
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>

    </>

  )
}
export default FreeTrialsList;